import React from 'react'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

const ModalButton = (props) => {
  return (<Button {...props} styles={{ text: { textTransform: 'none' } }} />)
}
export default ModalButton
